import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEqual, mapValues } from 'lodash';

import PageHeader from '../../components/PageHeader';
import Disclaimer from '../../components/Disclaimer';
import Iframe from '../../components/Iframe';

import { TabbedFilters, FilterTypes } from '../../components/Filters';

import config from './config';
import SeeHerPNG from './seeher.png';

export class GemReport extends React.Component {
  async componentDidMount() {
    const {
      filtersActions: { getFiltersForPage }
    } = this.props;

    await getFiltersForPage(config.GEM_REPORT_PAGE_ID);
  }

  componentDidUpdate(prevProps) {
    if (this.props.blocked) {
      return;
    }

    const prevFilterValues = mapValues(prevProps.filters.fields, 'value');
    const filterValues = mapValues(this.props.filters.fields, 'value');

    if (!isEqual(prevFilterValues, filterValues)) {
      this.updateLooks();
    }
  }

  updateLooks() {
    const {
      embedActions: { getLookerEmbedsForPage },
      filters
    } = this.props;

    getLookerEmbedsForPage(config.GEM_REPORT_FILTERS, filters.fields);
  }

  render() {
    const { blocked, looks } = this.props;

    return (
      <Fragment>
        <div className="gem-report-wrapper">
          <PageHeader title="GEM™ SCORE" />
          <img src={SeeHerPNG} className="gem-report-logo" alt="#SeeHer" />
        </div>
        {blocked && (
          <Iframe
            blocked
            blockedMessage="Contact your Client Success Representative to learn more about this report"
            url=""
            height="100%"
            useDefaultTitle={false}
          />
        )}
        {!blocked && (
          <Fragment>
            <TabbedFilters />
            <Iframe
              blocked={looks.gemReport.blocked}
              blockedMessage={looks.gemReport.blockedMessage}
              url={looks.gemReport.url}
              height="100%"
              useDefaultTitle={false}
            />
          </Fragment>
        )}
        <Disclaimer>
          <b>About this report</b>GEM scores are calculated from the responses
          of Frequent and Regular program viewers, as reported by the
          respondent. Each program received a minimum of 100 respondents during
          the designated testing period.
        </Disclaimer>
      </Fragment>
    );
  }
}

GemReport.propTypes = {
  blocked: PropTypes.bool.isRequired,

  embedActions: PropTypes.shape({
    getLookerEmbedsForPage: PropTypes.func.isRequired
  }).isRequired,

  filters: PropTypes.shape({
    fields: FilterTypes.FilterSetType, // eslint-disable-line react/no-typos
    groupings: FilterTypes.GroupingSetType // eslint-disable-line react/no-typos
  }).isRequired,

  filtersActions: PropTypes.shape({
    clearFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    getFiltersForPage: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired
  }).isRequired,

  looks: PropTypes.shape({
    gemReport: PropTypes.shape({})
  }).isRequired
};

export default GemReport;
